import React from 'react';
import { Link } from 'react-router-dom';
import { matchPath, useHistory } from 'react-router';
import { MenuList } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import FsBodyMediumBold from 'ui-elements/typography/FsBodyMediumBold';
import { UserBillingType, UserRole } from 'globals/types';
import { useBillingType } from 'globals/hooks/useBillingType';
import { StyledDivider, StyledMenuItem } from './NavMenu.style-elements';
import { isBillingLabel, items } from './NavMenu.utils';

interface NavMenuProps {
  onNavItemClick?: () => void;
}

const NavMenu: React.FC<NavMenuProps> = ({ onNavItemClick: handleClose }) => {
  const { isUpgraded, userRole = UserRole.USER } = useAppContext();
  const history = useHistory();
  const isBillingTypeExcluded = useBillingType(UserBillingType.EXCLUDED);

  const navItems = items
    .filter(({ availableFor }) => availableFor.includes(userRole))
    .filter(({ label }) => isUpgraded || !isBillingLabel(label))
    .filter(({ label }) => !isBillingTypeExcluded || !isBillingLabel(label));

  return (
    <MenuList>
      {navItems.map(({ label, iconComponent, to }) => {
        return label !== '' ? (
          <StyledMenuItem
            button
            key={label}
            selected={matchPath(history.location.pathname, to)?.isExact}
            component={Link}
            onClick={handleClose}
            to={to}
          >
            {iconComponent}
            <FsBodyMediumBold variant="inherit">{label}</FsBodyMediumBold>
          </StyledMenuItem>
        ) : (
          <StyledDivider key={label} />
        );
      })}
    </MenuList>
  );
};

export default NavMenu;
